// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"780":"5bb5292119487cab443b","897":"2aaed7131ecc4b95ad2d"}[chunkId] + ".chunk.js";
};